import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { InvoiceListTable } from "Invoices/Components/InvoiceListTable";
import { AuthenticatedLayout } from "Shared/Layouts/AuthenticatedLayout";

export const InvoicesPage = (): React.ReactNode => {
  const { t } = useResource();

  return (
    <AuthenticatedLayout
      preTitle={t(Resources.Common.Admin)}
      title={t(Resources.Invoices.Title)}
    >
      <InvoiceListTable isAdmin />
    </AuthenticatedLayout>
  );
};
